import { Button, Divider, Empty, Flex, List, Space, Typography } from 'antd';
import { FC, ReactElement } from 'react';
import { BoxArrowInUpRight, CheckCircleFill, Plus } from 'react-bootstrap-icons';
import { Link } from 'react-router-dom';

import { AppRoutes } from '@/common/interfaces';

import { Page, PageUsageForBots, PageUsageForKeys, PageUsageForTag, PageUsageForType } from '@/modules/Pages';

interface Props {
  siteId: string;
  pageId: string;
  nodeId: string;
  pages: Pick<Page, 'id' | 'title' | 'usageFor'>[];
}

const usageForItems: PageUsageForType[] = [
  {
    type: 'default'
  },
  {
    [PageUsageForKeys.Bot]: PageUsageForBots.Google
  }
];

const { Text } = Typography;

export const PagesVariantsList: FC<Props> = ({ siteId, pageId, nodeId, pages }) => {
  return (
    <List
      style={{ width: 200 }}
      className="app-list"
      dataSource={ usageForItems }
      locale={{
        emptyText: <Empty image={ Empty.PRESENTED_IMAGE_SIMPLE } description="Немає варіантів сторінки" style={{ marginBlock: 0 }}/>
      }}
      renderItem={ (usageForItem): ReactElement => {
        const page = pages.find(p => JSON.stringify(p.usageFor) === JSON.stringify(usageForItem));

        return (
          <List.Item
            extra={ [
              <Space key="buttons" size="small">
                {
                  pageId !== page?.id &&
                  <Link to={ AppRoutes.PagesEdit.replace(':siteId', siteId).replace(':pageId', page?.id ?? '') }>
                    <Button
                      key="go"
                      disabled={ !page }
                      size="small"
                      type="link"
                      icon={ <BoxArrowInUpRight size={ 18 }/> }
                    />
                  </Link>
                }
              </Space>
            ] }
            actions={ [
              <Flex key="actions" align="center" justify="center">
                {
                  page
                    ? <Text type="success">
                      <Flex key="exists" align="center" justify="center">
                        <CheckCircleFill size={ 18 } style={{ marginRight: 4 }}/>
                      </Flex>
                    </Text>
                    : <>
                      <Link to={ `${ AppRoutes.PagesCreate.replace(':siteId', siteId).replace(':nodeId', nodeId) }?usageForNum=1` }>
                        <Button key="create" size="small" type="link" icon={ <Plus size={ 18 }/> }/>
                      </Link>
                    </>
                }
                { pageId !== page?.id && <Divider type="vertical"/> }
              </Flex>
            ] }
          >
            <div style={{ width: '100%' }}>
              <PageUsageForTag value={ usageForItem }/>
            </div>
          </List.Item>
        );
      } }
    />
  );
};
